export default __webpack_public_path__ + "static/media/icon-filter.001d1d50.svg";